import { useNavigate } from "react-router";
import React from "react";
import { RecentSessions } from "./components/RecentSessions";
import { Assignments } from "./components/Assignments";
import { Templates } from "./components/Templates";

export default function Home() {
	const navigate = useNavigate();

	return (
		<>
			<RecentSessions />
			<Assignments />
			<Templates />
		</>
	);
}
